import reports from "./reducer";

export default reports;
